import { motion } from "motion/react";
import "./style.scss";

const Avatar = ({ user }) => {
  return user ? (
    <motion.span
      className="user-avatar"
      initial={{
        scale: 0.5
      }}
      animate={{
        scale: 1
      }}
      transition={{ type: "spring", stiffness: 500 }}
    >
      {user.firstName ? user.firstName.substring(0, 1) : "X"}
      {user.lastName ? user.lastName.substring(0, 1) : ""}
    </motion.span>
  ) : null;
};

export default Avatar;
